import _ from 'lodash';

import constants from '@constants';
import mappings from '@mappings';

/**
 * マッピングデータからlabelを取得する
 * @param mappings 対象となるマッピングデータ
 * @param value マッピングを行う値
 */
export const getLabel = (mappings: Mapping[], value?: Mapping['value']) => {
  const mapping = _.find(mappings, {value});

  if (mapping) {
    return mapping.label;
  } else {
    return '';
  }
};

/**
 * マッピングデータからvalueを取得する
 * @param mappings 対象となるマッピングデータ
 * @param value マッピングを行う値
 */
export const getValue = (mappings: Mapping[], label?: Mapping['label']) => {
  const mapping = _.find(mappings, {label});

  if (mapping) {
    return mapping.value;
  } else {
    return '';
  }
};

/**
 * マッピングデータからドロップダウンの選択肢を作成する
 * @param mappings 対象となるマッピングデータ
 */
export const createSelections = (mappings: Mapping[], isSearch?: boolean) => {
  const selections = mappings.map((mapping: Mapping, index: number) => {
    return {
      key: index + 1,
      value: mapping.value,
      text: mapping.label,
    };
  });

  // 空の選択肢を追加
  if (isSearch) {
    selections.push({
      key: 0,
      value: null,
      text: '',
    });
  }
  // 空の選択肢を一番上にする
  const _selections = _.orderBy(selections, ['key'], ['asc']);

  return _selections;
};

/**
 * ユーザー追加に使用する権限の選択肢を作成する
 * @param mappings 対象となるマッピングデータ
 */
export const userCreateSelection = (mappings: Mapping[]) => {
  const selections = mappings.filter(
    selection => selection.value !== constants.AUTHORITIES.SUPER_ADMIN
  );

  const _selections = selections.map((_selection: any, index: number) => {
    return {
      key: index,
      value: _selection.value,
      text: _selection.label,
    };
  });

  return _selections;
};

/**
 * valueに対応するデータを取得
 */
export const getPlan = (value: number) => {
  return _.find(mappings.plan, (p: any) => {
    return p.value === value;
  });
};
